module.exports = __webpack_public_path__ + "img/10.2581c115.png";